export const PAGE_SIZE = {
  LIST: 45,
  LIST_CU: 44
};

export const SCREEN_MODES = {
  SMALL: 0,
  MEDIUM: 1,
  LARGE: 2
};

export const IDENTIFIER = {
  LIGHT_PRICE: 'promo_702',
  PROMOTION: 'PROMOTION',
  WINEBOX: 'caisse-panachee',
  DECLINAISON: 'Attr'
};

export const FILTERS = {
  PARKER_NOTE: 'note_rp',
  PRICE: 'Price',
  MIN_PRICE: 'minPrice',
  MAX_PRICE: 'maxPrice',
  PACKAGING: 'conditionnement',
  DECLINAISON: 'declinaison',
  FORMAT: 'format',
  PROMOTION: 'promotion_o_n',
  IN_STOCK: 'in_stock',
  ONLY_CU: 'onlyCU'
};

export const FILTERS_TYPE = {
  BLOC: 'BLOC',
  CHECKBOX: 'CHECKBOX',
  PRICE: 'PRICE'
};

export const PRICE_FILTER_DEFAULT = {
  min: 0,
  max: 5000,
  step: 50
};

export const SORT = [
  { value: 1, label: 'popularite' },
  { value: 4, label: 'priceless' },
  { value: 5, label: 'pricemost' },
  { value: 2, label: 'nameaz' },
  { value: 3, label: 'nameza' }
];

export const SORT_ENUM = {
  POPULARITE: 1,
  NAMEAZ: 2,
  NAMEZA: 3,
  PRICELESS: 4,
  PRICEMOST: 5
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_SORT = 1;
